import { render, staticRenderFns } from "./service-autocomplete.vue?vue&type=template&id=b1635312&scoped=true"
import script from "./service-autocomplete.vue?vue&type=script&lang=js"
export * from "./service-autocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1635312",
  null
  
)

export default component.exports